"use client";
import { useEffect } from "react";

export default function PageViewTracker({ slug }: { slug: string }) {
  useEffect(() => {
    fetch(`/api/track/${slug}`, { method: "POST" }).catch(() => {});
  }, [slug]);
  return null;
}
